module.exports = __webpack_public_path__ + "img/ca29b22.svg";